import { getAffiliateMetadata } from './metadata';

/**
 * Единое аналитическое событие клика по партнёрской (outbound) ссылке.
 *
 * Вызывать на ВСЕХ outbound-ссылках во всех вертикалях
 * (esim / vpn / tours / transport / insurance / stay), чтобы можно было
 * считать CTR страницы → клик и сравнивать провайдеров/страны.
 *
 * Единственный источник события клика: легаси booking_click/accommodation_click
 * убраны 2026-08-11 (аудит §4.5) — воронка жилья считается здесь, vertical='stay'.
 *
 * @param {Object}  params
 * @param {string}  params.provider  — код/название провайдера ('airalo', 'nordvpn', ...)
 * @param {string}  params.vertical  — 'esim' | 'vpn' | 'tours' | 'transport' | 'insurance' | 'stay'
 * @param {string} [params.country]  — slug страны ('montenegro')
 * @param {string} [params.position] — место клика: 'hero' | 'plan_row' | 'promo' | 'card' | 'sticky' | 'bottom'
 * @param {string|number} [params.price] — цена/«от» (для якоря в отчётах)
 * @param {string} [params.label]    — текст ссылки
 */
// Единая таксономия вертикалей. Разные компоненты исторически слали синонимы
// (vertical-коды провайдер-доков Sanity против ключей карты офферов), и GA4 за
// 90д накопил transfer/transfers/transport + carRental/car_rental + bike/bike_rental —
// EPC по вертикали при таком дроблении не считается (аудит 2026-08-13, идея №9).
// Нормализуем в одной точке, а не по всем отправителям.
const VERTICAL_ALIASES = {
    transfers: 'transfer',
    trains: 'transfer',
    car_rental: 'carRental',
    bike_rental: 'bike',
    boat_rental: 'boat',
};

// Сервисные страницы несут вертикал прямо в URL — последний шанс, если ни проп,
// ни домен ссылки ничего не дали (главный источник «(not set)» — клики через
// tpo.li/pxf.io без вложенного target).
const PATH_VERTICALS = new Set(['esim', 'vpn', 'tours', 'stay', 'insurance', 'transport']);
function verticalFromPath(pathname) {
    const seg = (pathname || '').split('/').filter(Boolean); // [lang, country, service, ...]
    return seg.length >= 3 && PATH_VERTICALS.has(seg[2]) ? seg[2] : undefined;
}

export function trackAffiliateClick({ provider, vertical, country, position, price, label, href } = {}) {
    if (typeof window === 'undefined') return;

    const inferred = getAffiliateMetadata(href);
    let outboundId;
    try {
        const parsed = new URL(href, window.location.origin);
        outboundId = parsed.pathname === '/api/r' ? parsed.searchParams.get('subid') : undefined;
    } catch { }

    const rawVertical = vertical || inferred?.vertical || verticalFromPath(window.location.pathname) || 'unknown';
    const canonicalVertical = VERTICAL_ALIASES[rawVertical] || rawVertical;

    if (window.gtag) {
        window.gtag('event', 'affiliate_click', {
            provider: provider || inferred?.provider || 'unknown',
            vertical: canonicalVertical,
            country: country || undefined,
            position: position || undefined,
            price: price !== undefined && price !== null ? String(price) : undefined,
            link_label: label || undefined,
            link_domain: inferred?.destinationHost || undefined,
            page_path: window.location.pathname,
            outbound_id: outboundId || undefined,
        });
    }

    if (window.fbq) {
        window.fbq('track', 'Lead', {
            content_category: canonicalVertical === 'unknown' ? 'travel' : canonicalVertical,
            content_name: provider || inferred?.provider || undefined,
        });
    }
}
